import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import GrantAccessDialogLoaderQuery, {
	type GrantAccessDialogLoaderQuery$data,
	type GrantAccessDialogLoaderQuery$variables,
} from './__generated__/GrantAccessDialogLoaderQuery.graphql.ts';

export function preloadGrantAccessDialogData(contentId: string, accountId: string) {
	return query<GrantAccessDialogLoaderQuery$data, GrantAccessDialogLoaderQuery$variables>({
		query: GrantAccessDialogLoaderQuery,
		variables: { contentId, accountId },
	});
}
